import React, { useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import styled from 'styled-components'

import { toggleMenu } from '../../_actions'
import { useWindowSize } from '../../_helpers'
import {
    Image,
    UnstyledLink,
    devices,
    Hr,
    colors,
} from '../Common'


const NavigationItem = ({ toggle, header, links, open, closeMenu, URL }) => (
    <NavItem>
        <NavItemHeader
            as={links.length === 0 ? Link : ''}
            to={links.length === 0 ? URL : ''}
            onClick={links.length === 0 ? closeMenu(URL) : toggle}>
            {header}
        </NavItemHeader>
        {links.length > 0 ? (
            <NavItemContent open={open}>
                {links.map(item =>
                    <NavItemContentItem key={item.title}>
                        <UnstyledLink
                            as={item.url.match(/^https?/) ? 'a' : Link}
                            to={item.url.match(/^https?/) ? undefined : `${item.url}${item.hash ? `#${item.hash}` : ''}`}
                            href={item.url.match(/^https?/) ? item.url : undefined}
                            onClick={closeMenu(item.linked_page)}
                            rel={item.external_url ? 'noopener noreferrer' : ''}
                            target={item.external_url ? '_blank' : ''}
                        >
                            {item.title}
                        </UnstyledLink>
                    </NavItemContentItem>
                )}
            </NavItemContent>
        ) : ''}
    </NavItem>
)

export const Nav = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { menu, menuOpen } = useSelector(state => state.content)
    const { alert } = useSelector(state => state.content.page)
    const { width } = useWindowSize()
    const mobile = width < 480

    const [openNavItem, setOpenNavItem] = useState('')

    const changeLocation = location => e => {
        e.preventDefault()
        if (!location) return
        if (location !== history.location.pathname) {
            history.push(location)
        }
        dispatch(toggleMenu(false))
        document.body.style.overflow = 'visible'
    }

    const toggleNavItem = title => () => setOpenNavItem(title === openNavItem ? '' : title)

    // close individual menuItem
    const closeMenu = location => e => {
        dispatch(toggleMenu(false))
        document.body.style.overflow = 'visible'
        setOpenNavItem('')
        if (!location || e.metaKey) return
    }

    // Hide the entire side menu
    const closePanel = () => {
        dispatch(toggleMenu(false))
        setOpenNavItem('')
        document.body.style.overflow = 'visible'
    }

    return (
        <NavigationWrap open={menuOpen}>
            {mobile &&
                <MobileControls alert={!!alert}>
                    <MobileLogo />
                    <CloseButton role='button' aria-label='Close Menu' onClick={closePanel} />
                </MobileControls>
            }
            <Menu>
                {menu.map(link =>
                    <NavigationItem
                        key={link.title}
                        header={link.title}
                        changeLocation={changeLocation}
                        closeMenu={closeMenu}
                        toggle={toggleNavItem(link.title)}
                        open={openNavItem === link.title}
                        links={link.children}
                        URL={link.url}
                    />
                )}
                <Hr marginbottom={mobile ? 56 : 20} />
                <Hr margintop={mobile ? 0 : 20} marginbottom={20} />
            </Menu>
        </NavigationWrap>
    )
}

const MobileControls = styled.div`
    height: 65px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${({ alert }) => alert && 'margin-top: 75px;'}
`

const MobileLogo = styled.div`
    background: url('/static/images/sprite.svg') no-repeat -220px -210px;
    width: 223px;
    height: 30px;
`

const CloseButton = styled.div`
    width: 50px;
    height: 50px;
    background: url('/static/images/sprite.svg') no-repeat  13px -444px;
    ${({ border }) => border && `border: 1px solid ${colors.darkGreen};`}
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
`

const NavItem = styled.div`
    position: relative;
    /* color: #fff; */
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    @media ${devices.mobile} {
        margin-bottom: 0;
        padding-bottom: 20px;
    }
`

const NavigationWrap = styled.div`
    display: flex;
    flex-direction: row;
    width: 50vw;
    height: 100%;
    position: fixed;
    right: 0;
    flex: 1;
    z-index: 9999999;
    padding: 4vh 4vw;
    background: ${colors.pink};
    color: ${colors.darkGreen};
    transform: translateX(${({ open }) => open ? 0 : 100}%);
    transition: transform 0.5s ease-in-out;

    @media ${devices.mobile} {
        padding: 1vh 20px;
        width: 100vw;
        flex-direction: column;
        overflow: hidden;
        overflow-y: scroll;
    }
`

const Menu = styled.div`
    /* max-height: 100vh; */
    padding-bottom: 40px;
    overflow-x: hidden;

    ${NavItem} {
        width: 100%;
    }

    @media (max-width: 1450px) {
        padding-left: 0;
        padding-right: 0;
    }

    @media ${devices.mobile} {
        padding: 30px 0 0 0;
        margin-bottom: auto;
    }
`

const NavItemHeader = styled.div`
    font-size: 42px;
    // font-family: '';
    cursor: pointer;
    line-height: 48px;
    display: inline-flex;
    flex-direction: column;
    color: ${colors.darkGreen};

    img {
        position: absolute !important;
        left: 0px;
        top: 7px;
    }

    div {
        display: inline;
    }

    @media ${devices.tablet} {
        font-size: 28px;
    }

    @media ${devices.mobile} {
        font-size: 45px;
        padding-left: 0;
        ${Image} {
            height: 15px;
            top: 9px;
        }
    }
`

const NavItemContent = styled.div`
    display: ${({ open }) => open ? 'block' : 'none'};
    float: left;
    max-width: 670px;
    padding-left: 42px;

    @media ${devices.mobile} {
        padding-left: 0;
    }
`

const NavItemContentItem = styled.div`
    display: inline-block;
    width: 100%;
    font-weight: bold;

    @media ${devices.mobile} {
        margin-bottom: 10px;
        padding-left: 30px;
    }
`
